import React from 'react'
import { Block } from '@xprog/prensa'
import DropDownItem from './DropDownItem'
import { get } from 'lodash'

type DropDownAreaProps = {
  strings: any;
}

const DropDownArea: React.FC<DropDownAreaProps> = (props) => {
  const slugValue = get(props, "strings.contatos.slug", '');
  if (slugValue === 'tocantins') {
    return (
      <Block
        css={{
          align: ['column', 'left', 'middle'],
          width: '100%',
          '@lg': {
            maxWidth: '904px',
          }
        }}
      >
        <DropDownItem title='Publicidade Legal'>
          {props.strings}
        </DropDownItem>
        <DropDownItem title='Sugestão de pauta'>
          {props.strings}
        </DropDownItem>
        <DropDownItem title='Fale com a redação'>
          {props.strings}
        </DropDownItem>
        <DropDownItem title='Trabalhe conosco'>
          {props.strings}
        </DropDownItem>
        <DropDownItem title='Politica de Privacidade'>
          {props.strings}
        </DropDownItem>
        <DropDownItem title='Atendimento ao anunciante'>
          {props.strings}
        </DropDownItem>
      </Block>
    )
  }

  return (
    <Block
      css={{
        align: ['column', 'left', 'middle'],
        width: '100%',
        '@lg': {
          maxWidth: '904px',
        }
      }}
    >
      {/* FIXME rm classi */}
      <DropDownItem title='Anuncie no Classi'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Vendas de assinatura'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Atendimento ao assinante'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Atendimento ao anunciante'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Atendimento Classificados, Editais e Anúncios'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Sucursal São Paulo'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Sucursal Distrito Federal'>
        {props.strings}
      </DropDownItem>
      <DropDownItem title='Política de Privacidade'>
        {props.strings}
      </DropDownItem>
    </Block>
  )

}

export default DropDownArea
